import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { OverlayPositionBuilder } from '@angular/cdk/overlay';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { SnackBar } from './snackbar/snackbar.service';
import { reducer } from './reducers';
import { NotificationEffects } from './effects/notification.effects';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { ExtendedPositionBuilder } from './snackbar/snackbar-position-strategy';

/**
 * Notification Module
 *
 * @export
 * @class NotificationsModule
 */
@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    StoreModule.forFeature('notification', reducer),
    EffectsModule.forFeature([NotificationEffects])
  ],
  declarations: [SnackbarComponent],
  entryComponents: [SnackbarComponent],
  providers: [SnackBar, { provide: OverlayPositionBuilder, useClass: ExtendedPositionBuilder }],
  exports: []
})
export class NotificationsModule {}
